import React from 'react';
import { InstantSearch } from 'react-instantsearch';
import { searchClient } from '@/lib/search/instantsearch/typesenseAdapter';

interface InstantSearchProviderProps {
  indexName: 'sequences' | 'sequences_v2' | 'displays';
  children: React.ReactNode;
  routing?: boolean;
}

export const InstantSearchProvider: React.FC<InstantSearchProviderProps> = ({
  indexName,
  children,
  routing = true,
}) => {
  return (
    <InstantSearch
      searchClient={searchClient}
      indexName={indexName}
      routing={routing}
    >
      {children}
    </InstantSearch>
  );
};